import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { FileMinifiedFragmentDoc } from '../../fragments/generated/fileMinified';
import { EntityMediaFragmentDoc } from '../../../../../../../features/messages/graphql/fragments/generated/MediaType';
import { UserFragmentDoc } from '../../../../../../../graphql/fragments/generated/User';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type FileMinifiedQueryVariables = Types.Exact<{
  filters: Types.GetByIdFilter;
}>;


export type FileMinifiedQuery = { file?: { id: string, name: string, description?: string | null, createdAt: string, projectStatus?: Types.FileProjectStatusEnum | null, systemGenerated?: boolean | null, filterQuery?: string | null, category: Types.FileCategoryEnum, meta?: string | null, childrenIds?: Array<string> | null, taskCount?: number | null, dueDate?: string | null, iconSettings?: { type: Types.IconTypeEnum, value: string } | null, media?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null, createdBy?: { name?: string | null, profilePicture?: string | null } | null, clients: Array<{ id: string, clientName: string, clientIcon?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null }>, stages?: Array<{ stageId: string, name: string, progress: number } | null> | null, projectOwner?: { id: string, name?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } | null } | null };


export const FileMinifiedDocument = /*#__PURE__*/ gql`
    query fileMinified($filters: GetByIdFilter!) {
  file(filters: $filters) {
    ...FileMinified
  }
}
    ${FileMinifiedFragmentDoc}
${EntityMediaFragmentDoc}
${UserFragmentDoc}`;

export function useFileMinifiedQuery(options: Omit<Urql.UseQueryArgs<FileMinifiedQueryVariables>, 'query'>) {
  return Urql.useQuery<FileMinifiedQuery, FileMinifiedQueryVariables>({ query: FileMinifiedDocument, ...options });
};